export const formatObjectToQueryString = (obj: Record<string, string | number | boolean>) => {
  const params = new URLSearchParams();

  Object.entries(obj).forEach(([key, value]) => {
    params.append(key, String(value));
  });

  return params.toString().replace(/\+/g, '%20');
};
